import type { Meta, Stream, AddonManifest } from "@streamit/contracts";
import { core } from "@/lib/core";
import { contentMeta } from '../../../packages/slc-web/src/content';
import { metadataHttps } from '../../../packages/contracts/src/metadata';
export const CINEMETA = "https://v3-cinemeta.strem.io";
export const genres = [
  "All genres",
  "Action",
  "Adventure",
  "Animation",
  "Comedy",
  "Crime",
  "Documentary",
  "Drama",
  "Family",
  "Fantasy",
  "Horror",
  "Mystery",
  "Romance",
  "Sci-Fi",
  "Thriller",
];
export async function addonGet<T>(
  base: string,
  path: string,
  signal?: AbortSignal,
): Promise<T> {
  const response = await fetch(
    `${base.replace(/\/manifest\.json\/?$/, "").replace(/\/$/, "")}/${path}`,
    { signal },
  );
  if (!response.ok)
    throw new Error(
      `This addon could not respond (${response.status}). Try again or choose another catalog.`,
    );
  return response.json();
}
export function resourcePath(
  resource: string,
  type: string,
  id: string,
  extra: Record<string, string> = {},
) {
  const values = Object.entries(extra)
    .filter(([, v]) => v !== "")
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join("&");
  return `${[resource, type, id].map(encodeURIComponent).join("/")}${values ? "/" + values : ""}.json`;
}
export async function getCatalog(
  type: string,
  id = "top",
  extra: Record<string, string> = {},
  signal?: AbortSignal,
) {
  const url = await core<string>(
    {
      action: "resource_url",
      base: CINEMETA,
      resource: "catalog",
      type,
      id,
      extra,
    },
    signal,
  );
  const response = await fetch(url, { signal });
  if (!response.ok)
    throw new Error(
      `The catalog could not respond (${response.status}). Please try again.`,
    );
  const data = (await response.json()) as { metas?: Meta[] };
  return {
    metas: await core<Meta[]>(
      { action: "catalog", items: data.metas || [] },
      signal,
    ),
  };
}
export const getMeta = async (type: string, id: string, signal?: AbortSignal) => {
  const result = await addonGet<{ meta: unknown }>(CINEMETA, resourcePath("meta", type, id), signal);
  return { meta: contentMeta(result.meta) };
};
export const getManifest = (url: string, signal?: AbortSignal) =>
  addonGet<AddonManifest>(url, "manifest.json", signal);
export function safeImage(url?: string) {
  return metadataHttps(url);
}
export function streamLabel(stream: Stream) {
  return (
    stream.title ||
    stream.description ||
    stream.name ||
    stream.behaviorHints?.filename ||
    "Play source"
  );
}
